<template>
  <div
    v-if="hasSellingPlan"
    class="product__selling-plans"
  >
    <div
      class="product__subscribe"
      :class="{ 'subscribe-selected': subscribe }"
    >
      <label
        class="product__subscribe-head flex items-center justify-between"
        for="subscribe"
      >
        <input
          id="subscribe"
          v-model="subscribe"
          type="radio"
        >

        <h3 class="product__subscribe-title">
          {{ titles.subscribe }}
        </h3>

        <p class="product__subscribe-price ml-auto">
          <s>
            {{ originalPrice }}
          </s>
          <span>
            {{ selectedSellingPlan.price }}
          </span>
        </p>
      </label>

      <h4 class="product__subscribe-select-title">
        {{ titles.frequency }}
      </h4>
      <v-select
        v-model="selectedSellingPlan"
        class="product__subscribe-select"
        :options="sellingPlans"
        :clearable="false"
        :searchable="false"
        label="name"
      />
    </div>

    <label
      v-if="!product.requires_selling_plan"
      class="product__otp product__subscribe-head flex items-center justify-between"
      :class="{ 'subscribe-selected': subscribe }"
      for="otp"
    >
      <input
        id="otp"
        v-model="otp"
        type="radio"
      >
      <h3 class="product__subscribe-title">
        One Time Purchase
      </h3>

      <p class="product__subscribe-price ml-auto">
        {{ originalPrice }}
      </p>
    </label>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '../../pinia/ProductStore'
import { productPrice } from '../../helpers/product'

export default {
  props: {
    titles: {
      type: Object,
      default: null
    },
    isCombined: {
      type: Boolean,
      default: false
    },
    quickView: {
      type: Boolean,
      default: false
    },
    quickViewProduct: {
      type: Object,
      default: null
    },
    quickViewSelectedVariant: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      subscribe: false,
      otp: true,
      selectedSellingPlan: {}
    }
  },
  computed: {
    ...mapState (useProductStore, ['product', 'combinedListingsProductVariants', 'selectedVariant']),
    sellingPlanProduct () {
      if (this.isCombined) {
        return this.combinedListingsProductVariants.find(variant => variant.variants[0].id === this.selectedVariant.id)
      } else if (this.quickView) {
        return this.quickViewProduct.variants.find(variant => variant.id === this.quickViewSelectedVariant.id)
      }
      return this.product
    },
    hasSellingPlan () {
      return this.sellingPlanProduct.selling_plan_groups?.length > 0
    },
    originalPrice () {
      return productPrice(this.sellingPlanProduct.price)
    },
    price () {
      return '[price here]'
    },
    sellingPlans () {
      if (!this.hasSellingPlan) return []
      const sellingPlans = this.sellingPlanProduct.selling_plan_groups[0].selling_plans.map((sellingPlan, index) => {
        let discount = 0

        if (sellingPlan.price_adjustments.length > 0 && sellingPlan.price_adjustments[0].value_type === 'percentage') {
          discount = (this.sellingPlanProduct.price / 100) * sellingPlan.price_adjustments[0].value
        }

        const price = productPrice(this.sellingPlanProduct.price - discount)

        return {
          ...sellingPlan,
          price,
          priceNoFormat: this.sellingPlanProduct.price - discount
        }
      })

      return sellingPlans
    }
  },
  watch: {
    subscribe (subscribe) {
      if (subscribe) {
        this.changeSellingPlan(this.selectedSellingPlan)
      }
      this.otp = !subscribe
    },
    otp (otp) {
      if (otp) {
        this.changeSellingPlan(null)
      }
      this.subscribe = !otp
    },
    selectedSellingPlan () {
      if (this.subscribe) this.changeSellingPlan(this.selectedSellingPlan)
    },
    sellingPlanProduct () {
      this.selectedSellingPlan = this.hasSellingPlan ? this.sellingPlans[0] : null
    }
  },
  mounted () {
    this.selectedSellingPlan = this.sellingPlans[0]
  },
  methods: {
    ...mapActions(useProductStore, [
      'changeSellingPlan'
    ]),
  }
}
</script>
